import { v4 as uuidV4 } from "uuid"
// import type Todo from "../models/Todo";

export default [
    { id: uuidV4(), title: "Buy popcorns", content: "", checked: false },
    { id: uuidV4(), title: "Change T-Shirt", content: "", checked: false },
    { id: uuidV4(), title: "Pay Credit Card", content: "", checked: false },
    { id: uuidV4(), title: "Upgrade lincense", content: "", checked: false },
    { id: uuidV4(), title: "Sell old car", content: "", checked: false },
    { id: uuidV4(), title: "Sell TV", content: "", checked: false },
    { id: uuidV4(), title: "Write a key note", content: "", checked: false },
];